// style
import "./css/dashboard.css";

// components
import HeroSection from "../../components/pages/home/HeroSection";
import ExperienceSection from "../../components/pages/home/ExperienceSection";
import SkillsSection from "../../components/pages/home/SkillsSection";
import EducationSection from "../../components/pages/home/EducationSection";
import ShowcaseSection from "../../components/pages/home/ShowcaseSection";


const Dashboard = () => {
    return (
        <div className="container">
            <HeroSection />
            <ExperienceSection />
            <SkillsSection />
            <EducationSection />
            <ShowcaseSection />
        </div>
    );
};

export default Dashboard;
